import { Button, CircularProgress, Paper, Typography, useTheme } from "@mui/material";
import { useForm } from "react-hook-form";
import {  useContext, useEffect } from "react";
import { useMutation } from "react-query";
import {postVitals,getallbloodGroup, getvitalsById} from "../service";
import { useParams } from "react-router-dom";
import { VitalsDto } from "../types";
import { clinicId } from "../../../../constants";
import usePopup from "../../../../hooks/usePopup";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import { VitalsContext, VitalsContextType } from "./VitalsProvider";
import useAuthentication from "@hooks/useAuthentication";
const AddVitals  = ({ close }: { close: () => void }) => {
  const theme = useTheme();
  const { showSnackbar } = usePopup();
  const { encounterId} = useParams();
  const {user} = useAuthentication()
  const createdByIdd  = Number(user?.userId)
  console.log("createdByIddcreatedByIdd::",createdByIdd)
  const { control, handleSubmit, reset, watch, setValue, formState: { isDirty } } = useForm({
    mode: "onChange"
  });
  const { setEdit, edit, setsuccess,setShow } = useContext(VitalsContext) as VitalsContextType;
  const { mutate: saveVitals, isLoading: postVitalsLoading } = useMutation(
    postVitals,
    {
      onSuccess: (result) => {
        const typedResult = result as { responseIndicator: string; responseMessage: string };
        if (typedResult.responseIndicator == "success") {
          showSnackbar({
            message: typedResult.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          setsuccess(true);
          setShow(false);
          setEdit(null);
        } else {
          showSnackbar({
            message: typedResult.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "success",
          duration: 2000,
        });
      },
    }
  );

  const { mutate: getbloodGroups, data: bloodGroupList } = useMutation(getallbloodGroup);
  const { mutate: getvitals } = useMutation(getvitalsById);

  

  const transformToVitalsDto = (data: Record<string, any>): VitalsDto => {
    return {
      takenDate:data.takenDate||null,
      vitalSignsId: data.vitalId ? data.vitalId : null,
      encounterId: parseInt(encounterId as string),
      height: data.height ? parseInt(data.height) : null,
      weight: data.weight ? parseInt(data.weight) : null,
      bmi: data.bmi ? parseFloat(data.bmi) : null,
      bsa: data.bsa ? parseFloat(data.bsa) : null,
      systolicBP: data.systolicBP ? parseInt(data.systolicBP) : null,
      diastolicBP: data.diastolicBP ? parseFloat(data.diastolicBP) : null,
      respiratory: data.respiratory ? parseFloat(data.respiratory) : null,
      spo2: data.spo2 ? parseFloat(data.spo2) : null,
      immunisationHistory: data.immunisationHistory || null,
      painScale: data.painscale ? parseFloat(data.painscale) : null,
      heartRate: data.heartRate ? parseFloat(data.heartRate) : null,
      headCircumference: data.headCircumference ? parseFloat(data.headCircumference) : null,
      temperature: data.temperature ? parseFloat(data.temperature) : null,
      bloodGroup: data.bloodGroup?.name || null,
      sugar: data.sugar ? parseFloat(data.sugar) : null,
      clinicId: clinicId,
      createdId:createdByIdd
    };
  };

  const height = watch("height");
  const weight = watch("weight");

  const onSubmit = (data: any) => {
    if ((height && !weight) || (!height && weight)) {
      const missingField = height ? 'Weight' : 'Height';
      const existField = height ? 'Height' : 'Weight';
      showSnackbar({
        message: `${missingField} is required while entering ${existField}`,
        open: true,
        variant: "warning",
        duration: 2000,
      });
      return;
    }
    if (!isDirty) {
      showSnackbar({
        message: "No changes made",
        open: true,
        variant: "info",
        duration: 2000,
      });
      return;
    }
    const vitalsDto = transformToVitalsDto(data);
    saveVitals(vitalsDto);
  };


  const handleClose = () => {
    close && close();
    setEdit(null);
    setShow(false);
  }



  const calculateMetrics = () => {
    const height = watch("height");
    const weight = watch("weight");
    if (!weight || !height || weight === 0 || height === 0 || isNaN(weight) || isNaN(height)) {
      setValue("bmi", "");
      setValue("bsa", "");
      return;
    }
    
    const bmi = parseFloat(((weight * 10000) / (height * height)).toFixed(2));
    const bsa = parseFloat(
      (0.007184 * Math.pow(height, 0.725) * Math.pow(weight, 0.425)).toFixed(2)
    );
    setValue("bmi", bmi);
    setValue("bsa", bsa);
  };

  useEffect(() => {
    getbloodGroups();
    getvitals(parseInt(encounterId as string));
  }, []);

  useEffect(() => {
    if (edit) {
      reset({ ...edit });
    }
  }, [edit]);

  return (
    <div className="border-2 rounded">
      <div className="border-b rounded-t p-2" style={{}}>
        <Typography color={theme.palette.primary.main} fontWeight={600}>
          {Boolean(edit) ? "Update" : "Add"} Vitals
        </Typography>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
                <Paper className="grid grid-cols-12 p-4 gap-2">
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="height"
                            rules={{ required: false,onChange:calculateMetrics}}
                            fieldProps={{ label: "height",type:"number"}}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="weight"
                            rules={{ required: false,onChange:calculateMetrics}}
                            fieldProps={{ label: "weight" ,type:"number"}}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="bmi"
                            rules={{ required: false ,}}
                            fieldProps={{ label: "bmi",InputProps:{readOnly:true}}}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="bsa"
                            rules={{ required: false }}
                            fieldProps={{ label: "bsa",InputProps:{readOnly:true} }}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="temperature"
                            rules={{ required: "Temparaure required", min: {
                                value: 30,
                                message: "Temperature must be at least 30",
                              },
                              max: {
                                value: 40,
                                message: "Temperature must not exceed 40",
                              } }}
                            fieldProps={{ label: "Temparature", type: "number"  }}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="spo2"
                            rules={{ required: false ,min:{value:1,message:"value ranges from 1 to 100"}, max:{value:100,message:"value ranges from 1 to 100"}}}
                            fieldProps={{type:"number",label: "spo2(%)"}}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="systolicBP"
                            rules={{ required: false ,min:{value:1,message:"value ranges from 1 to 300"}, max:{value:300,message:"value ranges from 0 to 300"}}}
                            fieldProps={{ label: "systolic Bp(mm hg)",type:"number" }}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="diastolicBP"
                            rules={{ required: false ,min:{value:1,message:"value ranges from 1 to 300"}, max:{value:300,message:"value ranges from 0 to 300"}}}
                            fieldProps={{ label: "diastolic Bp(mm hg)",type:"number" }}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="heartRate"
                            rules={{ required: false ,min:{value:30,message:"value ranges from 30 to 220"}, max:{value:220,message:"value ranges from 30 to 220"}}}
                            fieldProps={{ label: "Pulse/ Heart Rate (bpm)",type:"number" }}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="respiratory"
                            rules={{ required: false ,min:{value:5,message:"value ranges from 5 to 60"}, max:{value:60,message:"value ranges from 5 to 60"}}}
                            fieldProps={{ label: "respiratory(Breath/m)",type:"number"}}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="painscale"
                            rules={{ required: false ,min:{value:1,message:"value ranges from 1 to 10"}, max:{value:10,message:"value ranges from 0 to 10"}}}
                            fieldProps={{ label: "painscale(NRS)" ,type:"number"}}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="headCircumference"
                            rules={{ required: false ,min:{value:15,message:"value ranges from 15 to 70"}, max:{value:70,message:"value ranges from 15 to 70"}}}
                            fieldProps={{ label: "Head Circumference (cm)",type:"number" }}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="autocomplete"
                            name="bloodGroup"
                            options={bloodGroupList||[]}
                            rules={{required:false}}
                            autocompleteProps={{
                                getOptionLabel:(item)=>(item.name),
                                isOptionEqualToValue:(item,value)=>(item.id==value.id)
                            }
                            }
                           fieldProps={{label:"blood group"}}
                        />
                    </div>
                    <div className="col-span-3">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="sugar"
                            rules={{ required: false, min: { value: 0, message: "Value must be at least 0" }}}
                            fieldProps={{ label: "sugar", type: "number" }}
                        />
                    </div>
                    <div className="col-span-6">
                        <CustomFormField
                            control={control}
                            element="input"
                            name="immunisationHistory"
                            rules={{ required: false }}
                            fieldProps={{ label: "immunisation History" }}
                        />
                    </div>
                    

                    <div className="col-span-12 flex justify-end gap-x-3  items-center ">
                        <Button disabled={postVitalsLoading} type="submit" color="primary" >
                            save
                        </Button> 
                     { postVitalsLoading &&  <CircularProgress  size={18} />}
                        <Button  onClick={()=>handleClose()} color="error" >
                          Close
                        </Button>
                    </div>
                </Paper>
            </form>
    </div>
  );
};

export default AddVitals;


